<div [ngClass]="{even}" class="wrapper">
  <div class="image"><mat-icon>account_circle</mat-icon></div>
  <div class="info">
    <div class="main_info">
      <div>
        <a [routerLink]="['/client/profile', client?.id]" target="_blank">{{ client?.name || 'Клиент без имени' }} {{ client?.surname }}</a><small class="clientId">№{{ client?.id }}</small>
      </div>
      <span>{{ phoneSummary }}</span>
    </div>
    <div class="cars">
      <div class="carWrapper" *ngFor="let car of client?.cars">
        <small class="title">{{ car.description }}</small>
        <span>{{ car.vin }}</span>
      </div>
    </div>
  </div>
</div>
